import React from 'react';
import { useHistory } from 'react-router-dom';
import { EditOutlined, DeleteOutlined, FireOutlined, CalendarOutlined } from '@ant-design/icons';
import type { OfertaResponse } from '../../../../store/MSCommerce/Ofertas/types';
import { getOfertaBadge, getDiasRestantes, formatFecha, getAplicaANombres, getEstadoLabel } from '../ofertaDisplay';
import styles from '../Ofertas.module.scss';

interface OfertaCardProps {
  oferta: OfertaResponse;
  isAdmin?: boolean;
  onEdit?: (oferta: OfertaResponse) => void;
  onDelete?: (id: string) => void;
}

export const OfertaCard: React.FC<OfertaCardProps> = ({ oferta, isAdmin, onEdit, onDelete }) => {
  const history = useHistory();
  const badge = getOfertaBadge(oferta);
  const dias = getDiasRestantes(oferta.fechaFin);
  const estado = getEstadoLabel(oferta);
  const urgente = dias !== null && dias > 0 && dias <= 5 && estado.kind === 'activa';
  const productos = oferta.detalles.filter(d => d.tipoReferencia === 'PRODUCTO' && d.nombreReferencia);

  return (
    <div className={`${styles.ofertas__card} ${estado.kind !== 'activa' ? styles['ofertas__card--muted'] : ''}`}>
      {badge && <span className={styles.ofertas__badge}>{badge}</span>}

      {isAdmin && estado.kind !== 'activa' && (
        <span className={`${styles.ofertas__statusTag} ${styles[`ofertas__statusTag--${estado.kind}`]}`}>
          {estado.label}
        </span>
      )}

      <div className={styles.ofertas__cardBody}>
        <h3 className={styles.ofertas__cardTitle}>{oferta.nombre}</h3>
        {productos.length > 0 ? (
          <div className={styles.ofertas__cardProductLinks}>
            {productos.map(p => (
              <button
                key={p.referenciaId}
                className={styles.ofertas__cardProductLink}
                onClick={() => history.push(`/products/${p.referenciaId}`)}
              >
                {p.nombreReferencia}
              </button>
            ))}
          </div>
        ) : (
          <p className={styles.ofertas__cardApplies}>{getAplicaANombres(oferta)}</p>
        )}

        <div className={styles.ofertas__cardMeta}>
          <span className={styles.ofertas__cardDate}>
            <CalendarOutlined /> Válida hasta {formatFecha(oferta.fechaFin)}
          </span>
          {urgente && (
            <span className={styles.ofertas__urgency}>
              <FireOutlined /> ¡Termina en {dias} día{dias === 1 ? '' : 's'}!
            </span>
          )}
        </div>

        {isAdmin && (
          <div className={styles.ofertas__cardActions}>
            <button className={styles.ofertas__editBtn} onClick={() => onEdit?.(oferta)}>
              <EditOutlined /> Editar
            </button>
            <button className={styles.ofertas__deleteBtn} onClick={() => onDelete?.(oferta.id)}>
              <DeleteOutlined /> Eliminar
            </button>
          </div>
        )}
      </div>
    </div>
  );
};
